<template>
    <div class="join">
        <!-- 头部 -->
        <div class="header">
            <div class="header-left" @click="back">
                <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
                <p>加入我们</p>
            </div>
            <div class="header-right" @click="toHome">
                <span class="iconfont iconshouye"></span>
            </div>
        </div>
        <!-- 标题 -->
        <div style="color:red;text-align:center;padding:10px 0px;">
            <span style="font-size:16px;">招聘</span>
            <span style="font-size:20px;">招聘</span>
            <span style="font-size:24px;">招聘啦！</span>
        </div>
        <!-- 图片 -->
        <img src="http://www.lungchuenjz.cn/upload/images/common/joinus201809.jpg" alt="" style="width:100%;">
        <!-- 表单标题 -->
        <div class="formTitle">
            有意向者请如实填写以下表格，我们会尽快与您联系。
        </div>
        <!-- 表单 -->
        <van-cell-group>
            <div class="fieldItem"><van-field v-model="name"  label="姓名" placeholder="请输入您的姓名" /></div>
            <div class="fieldItem"><van-field v-model="phone"  label="手机号码" placeholder="请输入您的手机号码" type="number"/></div>
            <div class="fieldItem"><van-field v-model="age"  label="年龄" placeholder="请输入您的年龄" type="number"/></div>
            <div class="fieldItem" @click="focusGender"><van-field v-model="gender"  label="性别" placeholder="" disabled/></div>
            <div class="fieldItem" @click="focusExperience"><van-field v-model="experience"  label="是否有经验" placeholder="" disabled/></div>
        </van-cell-group>
        <!-- 提交按钮 -->
        <div class="foot">
            <div class="btn" @click="confirmJoin">提交</div>
        </div>
        <!-- 选择器 -->
        <van-popup v-model="isShowGender" position="bottom" :overlay="true">
                <van-picker :columns="genderColumns" show-toolbar title="选择性别" @cancel="onCancelGender" @confirm="onConfirmGender" v-if="isShowGender"/>
         </van-popup>
         <!-- 选择器 -->
        <van-popup v-model="isShowExperience" position="bottom" :overlay="true">
                <van-picker :columns="experienceColumns" show-toolbar title="是否有经验" @cancel="onCancelExperience" @confirm="onConfirmExperience" v-if="isShowExperience"/>
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { setTimeout } from 'timers';
export default {
    data(){
        return{
            isShowGender:false,
            isShowExperience:false,
            name:'',
            phone:'',
            age:'',
            gender:'',
            experience:'',
            genderColumns:['男','女'],
            experienceColumns:['是','否']
        }
    },
    methods:{
        back () {
            this.$router.back()
        },
        toHome () {
            this.$router.push('/')
        },
        focusGender () {
            this.isShowGender = true
        },
        onCancelGender(){
            this.isShowGender = false
        },
        onConfirmGender (value, index) {
            this.gender = value
            this.isShowGender = false
        },
        focusExperience () {
            this.isShowExperience = true
        },
        onCancelExperience(){
            this.isShowExperience = false
        },
        onConfirmExperience (value, index) {
            this.experience = value
            this.isShowExperience = false
        },
        confirmJoin(){
           if(!this.name) { return Toast.fail('请输入姓名！'); }
           if(!this.phone) { return Toast.fail('请输入手机号码！'); }
           if(!this.age) { return Toast.fail('请输入年龄！'); }
           if(!this.gender) { return Toast.fail('请选择性别！'); }
           if(!this.experience) { return Toast.fail('请选择是否有经验！'); } 
           this.$axios.post('/api/DjCommon/JoinUs',{
                UserName:this.name,
                UserPhone:this.phone,
                UserAge:this.age,
                UserGender:this.gender,
                HasExperience:this.experience
            }).then((res)=>{
                if(res.data.type == 1){
                    Toast.success('您的信息已成功提交，我们会尽快与您联系。');
                    setTimeout(() => { location.reload() },3000)
                    //this.$router.go(0)
                }else{
                    Toast.fail('提交失败！');
                }
            })
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.join
  width 100%
  background #f0f0f0
  & .fieldItem
    border-bottom 1px solid #eeeeee
  &>>> .van-field__control:disabled
    color #323233;
  .header
    width: 100%
    display: flex
    justify-content: space-between
    width: 100%
    height: 40px
    align-items: center
    font-weight: bold
    border-bottom: 1px solid #eee
    background: #009933
    color: white
    .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
    .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
      &>.iconshouye
        font-size: 22px
  .formTitle
    font-size 20px
    padding 10px
    border-top 4px solid #009933;
    margin-top 4px
  .foot
    width 100%
    padding 14px 0px
    display flex
    align-items center
    justify-content center
    .btn
      width 80%
      padding 12px 0px
      background: #009933
      color white
      display flex
      align-items center
      justify-content center
      border-radius 20px
</style>



// WEBPACK FOOTER //
// src/pages/Join/Join.vue